var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _g, _path28, _path29, _path30, _path31, _g2, _path32, _path33, _path34, _g3, _path35, _path36, _g4, _path37, _path38, _g5, _path39, _path40, _path41, _path42, _g6, _path43, _path44, _g7, _path45, _path46, _g8, _path47, _path48, _g9, _path49, _path50, _path51, _path52, _g10, _path53, _path54, _g11, _path55, _path56, _g12, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSaf(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 380,
    height: 300,
    viewBox: "0 0 380 300",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_338_318)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M104.766 226.326H107.879L106.317 215.874L104.766 226.326ZM108.882 232.866L108.325 229.121H104.346L103.792 232.866H100.822L104.11 212.221H108.859L112.153 232.866H108.882Z",
    fill: "#354825"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M126.202 217.325V220.011C126.202 223.315 124.603 225.111 121.363 225.111H119.837V232.866H116.597V212.221H121.363C124.603 212.219 126.202 214.015 126.202 217.325ZM119.837 215.172V222.164H121.363C122.4 222.164 122.954 221.691 122.954 220.212V217.116C122.954 215.643 122.4 215.17 121.363 215.17H119.837V215.172Z",
    fill: "#354825"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M140.395 217.325V220.011C140.395 223.315 138.794 225.111 135.55 225.111H134.027V232.866H130.788V212.221H135.55C138.794 212.219 140.395 214.015 140.395 217.325ZM134.027 215.172V222.164H135.55C136.586 222.164 137.151 221.691 137.151 220.212V217.116C137.151 215.643 136.588 215.17 135.55 215.17H134.027V215.172Z",
    fill: "#354825"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M155.078 232.866H151.805L151.244 229.124H147.271L146.712 232.866H143.743L147.039 212.221H151.771L155.078 232.866ZM147.684 226.326H150.81L149.252 215.876L147.684 226.326Z",
    fill: "#354825"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M166.296 232.864C166.124 232.338 165.999 232.014 165.999 230.336V227.09C165.999 225.167 165.358 224.463 163.887 224.463H162.766V232.866H159.526V212.221H164.415C167.769 212.221 169.21 213.78 169.21 216.974V218.592C169.21 220.717 168.535 222.102 167.09 222.783C168.71 223.458 169.241 225.024 169.241 227.178V230.359C169.241 231.369 169.272 232.104 169.601 232.866H166.296V232.864ZM162.764 215.172V221.518H164.037C165.237 221.518 165.981 220.987 165.981 219.336V217.294C165.981 215.822 165.47 215.174 164.328 215.174H162.764V215.172Z",
    fill: "#354825"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M177.542 220.921H181.993V223.865H177.542V229.919H183.139V232.864H174.304V212.217H183.139V215.168H177.542V220.921Z",
    fill: "#354825"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M188.086 212.217H191.319V229.917H196.657V232.862H188.086V212.217Z",
    fill: "#354825"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M211.755 221.392H215.938V224.343H211.755V232.866H208.513V212.221H217.086V215.172H211.755V221.392Z",
    fill: "#354825"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M221.323 217.172C221.323 213.864 223.063 211.98 226.238 211.98C229.424 211.98 231.16 213.864 231.16 217.172V227.907C231.16 231.216 229.424 233.099 226.238 233.099C223.063 233.099 221.323 231.216 221.323 227.907V217.172ZM224.558 228.117C224.558 229.589 225.212 230.158 226.238 230.158C227.266 230.158 227.916 229.589 227.916 228.117V216.971C227.916 215.488 227.264 214.934 226.238 214.934C225.212 214.934 224.558 215.488 224.558 216.971V228.117Z",
    fill: "#354825"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M242.965 232.864C242.79 232.338 242.674 232.014 242.674 230.336V227.09C242.674 225.167 242.022 224.463 240.549 224.463H239.43V232.866H236.194V212.221H241.083C244.433 212.221 245.885 213.78 245.885 216.974V218.592C245.885 220.717 245.205 222.102 243.762 222.783C245.382 223.458 245.907 225.024 245.907 227.178V230.359C245.907 231.369 245.943 232.104 246.269 232.866H242.965V232.864ZM239.43 215.172V221.518H240.703C241.908 221.518 242.645 220.987 242.645 219.336V217.294C242.645 215.822 242.144 215.174 240.996 215.174H239.43V215.172Z",
    fill: "#354825"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M254.065 212.217V228.15C254.065 229.618 254.717 230.16 255.743 230.16C256.775 230.16 257.425 229.618 257.425 228.15V212.217H260.482V227.936C260.482 231.24 258.837 233.132 255.658 233.132C252.48 233.132 250.827 231.24 250.827 227.936V212.217H254.065Z",
    fill: "#354825"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M272.49 226.875L274.702 212.217H279.2V232.862H276.145V218.057L273.902 232.862H270.843L268.434 218.264V232.862H265.61V212.217H270.104L272.49 226.875Z",
    fill: "#354825"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M133.473 198.75C132.447 197.997 131.554 197.349 131.554 196.103C131.554 194.2 132.653 194.2 133.024 194.2C133.992 194.2 134.491 194.846 134.491 196.117V196.711H135.822V196.169C135.822 194.088 134.796 192.904 133.006 192.904C131.189 192.925 130.185 194.074 130.185 196.15C130.185 198.015 131.454 198.937 132.568 199.753C133.593 200.497 134.466 201.135 134.466 202.362C134.466 204.254 133.338 204.254 132.977 204.254C132.601 204.254 131.467 204.254 131.467 202.362V201.407H130.131V202.314C130.131 204.381 131.174 205.568 132.981 205.568C134.794 205.568 135.841 204.381 135.841 202.314C135.841 200.468 134.576 199.558 133.473 198.75Z",
    fill: "#354825"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M145.882 202.314C145.882 203.608 145.375 204.27 144.393 204.27C143.408 204.27 142.916 203.61 142.916 202.314V193.008H141.543V202.27C141.543 204.372 142.578 205.568 144.376 205.568C146.164 205.568 147.203 204.37 147.203 202.27V193.008H145.882V202.314Z",
    fill: "#354825"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M156.255 198.75C155.227 197.997 154.343 197.349 154.343 196.103C154.343 194.2 155.441 194.2 155.807 194.2C156.776 194.2 157.273 194.846 157.273 196.117V196.711H158.612V196.169C158.612 194.088 157.578 192.904 155.788 192.904C153.965 192.925 152.968 194.074 152.968 196.15C152.968 198.015 154.241 198.937 155.354 199.753C156.376 200.497 157.254 201.135 157.254 202.362C157.254 204.254 156.126 204.254 155.759 204.254C155.383 204.254 154.251 204.254 154.251 202.362V201.407H152.92V202.314C152.92 204.381 153.958 205.568 155.78 205.568C157.582 205.568 158.623 204.381 158.623 202.314C158.623 200.468 157.368 199.558 156.255 198.75Z",
    fill: "#354825"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M163.991 194.312H166.417V205.468H167.775V194.312H170.192V193.008H163.991V194.312Z",
    fill: "#354825"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M178.333 192.994L178.298 192.838L178.265 192.994H177.517L174.809 205.467H176.115L176.716 202.84H179.926L180.52 205.467H181.899L179.131 192.994H178.333ZM176.959 201.575L178.304 195.529L179.683 201.575H176.959Z",
    fill: "#354825"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M188.867 193.008H187.498V205.468H188.867V193.008Z",
    fill: "#354825"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M199.284 201.617L196.233 193.007H195.479L195.427 192.861V193.007H194.713V205.467H196.019V196.319L199.219 205.467H200.59V193.007H199.284V201.617Z",
    fill: "#354825"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M209.701 192.994L209.666 192.838L209.637 192.994H208.887L206.172 205.467H207.483L208.077 202.84H211.296L211.89 205.467H213.269L210.496 192.994H209.701ZM208.326 201.575L209.67 195.529L211.045 201.575H208.326Z",
    fill: "#354825"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M223.368 198.837C224.245 198.314 224.375 197.348 224.375 196.509V195.822C224.375 193.901 223.509 193.008 221.653 193.008H218.874V205.468H221.709C223.595 205.468 224.591 204.422 224.591 202.426V201.394C224.591 200.135 224.182 199.282 223.368 198.837ZM220.234 194.312H221.642C222.65 194.312 223.001 194.713 223.001 195.901V196.663C223.001 197.888 222.61 198.248 221.26 198.248H220.232V194.312H220.234ZM223.227 202.411C223.227 203.641 222.77 204.168 221.709 204.168H220.232V199.548H221.418C222.735 199.548 223.225 200.036 223.225 201.344V202.411H223.227Z",
    fill: "#354825"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M231.717 193.008H230.352V205.468H235.442V204.168H231.717V193.008Z",
    fill: "#354825"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M241.093 205.468H246.362V204.168H242.47V199.803H245.696V198.499H242.47V194.312H246.362V193.008H241.093V205.468Z",
    fill: "#354825"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M125.023 204.893H116.568V205.482H125.023V204.893Z",
    fill: "#354825"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M260.528 204.893H252.073V205.482H260.528V204.893Z",
    fill: "#354825"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_338_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 67,
    width: 155,
    height: 112
  }, _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M263.77 67.2012H109.862V178.853H263.77V67.2012Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_338_318)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask1_338_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 109,
    y: 67,
    width: 155,
    height: 112
  }, _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M263.77 67.2012H109.862V178.853H263.77V67.2012Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_338_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M227.171 139.325C232.338 130.852 237.127 119.829 240.892 105.484C231.025 109.628 222.949 114.062 216.332 118.581C217.134 110.541 217.134 101.231 216.002 90.4611C207.836 98.2241 201.637 105.582 196.956 112.454C194.626 94.0809 191.024 75.0577 186.829 67.1992C182.638 75.0619 179.029 94.0955 176.695 112.483C172.018 105.607 165.812 98.2303 157.632 90.4611C156.496 101.231 156.496 110.539 157.298 118.581C150.687 114.062 142.602 109.628 132.738 105.484C136.499 119.829 141.29 130.854 146.463 139.325C127.313 133.211 109.862 131.536 109.862 131.536C109.862 131.536 112.595 136.225 134.31 154.546C149.894 167.694 159.576 168.515 159.576 168.515H182.908C184.445 170.411 184.287 178.853 184.287 178.853H186.831H189.371C189.371 178.853 189.218 170.411 190.755 168.515H214.054C214.054 168.515 223.736 167.694 239.326 154.546C261.041 136.225 263.774 131.536 263.774 131.536C263.774 131.536 246.323 133.211 227.171 139.325Z",
    fill: "white"
  })))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask2_338_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 90,
    width: 34,
    height: 78
  }, _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M216.897 90.4609H183.71V167.594H216.897V90.4609Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_338_318)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask3_338_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 90,
    width: 34,
    height: 78
  }, _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M216.897 90.4609H183.71V167.594H216.897V90.4609Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_338_318)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask4_338_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 90,
    width: 34,
    height: 78
  }, _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M216.002 90.4609H183.71V167.594H216.002V90.4609Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_338_318)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask5_338_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 90,
    width: 34,
    height: 78
  }, _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M216.002 90.4609H183.71V167.594H216.002V90.4609Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_338_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.002 90.4609L187.583 167.594C187.583 167.594 168.238 135.84 216.002 90.4609Z",
    fill: "#2E8258"
  })))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_338_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 183,
    y: 90,
    width: 34,
    height: 78
  }, _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M216.897 90.4609H183.71V167.594H216.897V90.4609Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_338_318)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask7_338_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 187,
    y: 90,
    width: 30,
    height: 78
  }, _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M216.897 90.4609H187.6V167.53H216.897V90.4609Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_338_318)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask8_338_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 187,
    y: 90,
    width: 30,
    height: 78
  }, _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M216.897 90.4609H187.6V167.53H216.897V90.4609Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask8_338_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M216.002 90.4609L187.6 167.528C187.6 167.528 222.905 156.039 216.002 90.4609Z",
    fill: "#2F7C43"
  })))))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask9_338_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 186,
    y: 105,
    width: 55,
    height: 63
  }, _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M240.894 105.482H186.811V167.522H240.894V105.482Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask9_338_318)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask10_338_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 186,
    y: 105,
    width: 55,
    height: 63
  }, _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M240.894 105.482H186.811V167.522H240.894V105.482Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask10_338_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.892 105.482L187.044 167.522C187.044 167.522 180.178 130.966 240.892 105.482Z",
    fill: "#338553"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask11_338_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 187,
    y: 105,
    width: 54,
    height: 63
  }, _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M240.892 105.482H187.079V167.478H240.892V105.482Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask11_338_318)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask12_338_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 187,
    y: 105,
    width: 54,
    height: 63
  }, _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M240.892 105.482H187.079V167.478H240.892V105.482Z",
    fill: "white"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask12_338_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M240.892 105.482L187.079 167.472C187.079 167.472 224.159 169.264 240.892 105.482Z",
    fill: "#2F7648"
  })))), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M186.551 167.521V168.514H214.052C214.052 168.514 223.734 167.694 239.324 154.546C261.039 136.225 263.772 131.535 263.772 131.535L186.551 167.521Z",
    fill: "#2C3E22"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M186.551 167.521L263.772 131.535C263.772 131.535 224.652 135.296 199.282 152.079C190.595 157.833 187.313 163.75 187.313 163.75L186.551 165.042V167.521Z",
    fill: "#326533"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask13_338_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 157,
    y: 90,
    width: 33,
    height: 78
  }, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M189.926 90.4609H157.634V167.594H189.926V90.4609Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask13_338_318)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask14_338_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 157,
    y: 90,
    width: 33,
    height: 78
  }, _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M189.926 90.4609H157.634V167.594H189.926V90.4609Z",
    fill: "white"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask14_338_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.634 90.4609L186.053 167.594C186.051 167.594 205.396 135.84 157.634 90.4609Z",
    fill: "#2E8258"
  }))))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask15_338_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 156,
    y: 90,
    width: 31,
    height: 78
  }, _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M186.032 90.4609H156.737V167.53H186.032V90.4609Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask15_338_318)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask16_338_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 156,
    y: 90,
    width: 31,
    height: 78
  }, _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M186.032 90.4609H156.737V167.53H186.032V90.4609Z",
    fill: "white"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask16_338_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M157.634 90.4609L186.032 167.528C186.032 167.528 150.72 156.039 157.634 90.4609Z",
    fill: "#2F7C43"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask17_338_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 132,
    y: 105,
    width: 55,
    height: 63
  }, _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M186.821 105.482H132.738V167.522H186.821V105.482Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask17_338_318)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask18_338_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 132,
    y: 105,
    width: 55,
    height: 63
  }, _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M186.821 105.482H132.738V167.522H186.821V105.482Z",
    fill: "white"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask18_338_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.738 105.482L186.589 167.52C186.589 167.522 193.448 130.966 132.738 105.482Z",
    fill: "#338553"
  })))), /*#__PURE__*/React.createElement("mask", {
    id: "mask19_338_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 132,
    y: 105,
    width: 55,
    height: 63
  }, _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M186.551 105.482H132.738V167.478H186.551V105.482Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask19_338_318)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask20_338_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 132,
    y: 105,
    width: 55,
    height: 63
  }, _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M186.551 105.482H132.738V167.478H186.551V105.482Z",
    fill: "white"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask20_338_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M132.738 105.482L186.551 167.472C186.551 167.472 149.475 169.264 132.738 105.482Z",
    fill: "#2F7648"
  })))), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M187.081 167.521V168.514H159.578C159.578 168.514 149.894 167.694 134.31 154.546C112.595 136.225 109.862 131.535 109.862 131.535L187.081 167.521Z",
    fill: "#2C3E22"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M187.081 167.521L109.862 131.535C109.862 131.535 148.976 135.296 174.348 152.079C183.039 157.833 186.321 163.75 186.321 163.75L187.079 165.042V167.521H187.081Z",
    fill: "#326533"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask21_338_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 186,
    y: 67,
    width: 14,
    height: 112
  }, _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M199.774 67.2012H186.829V178.853H199.774V67.2012Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask21_338_318)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask22_338_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 186,
    y: 67,
    width: 14,
    height: 112
  }, _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M199.774 67.2012H186.829V178.853H199.774V67.2012Z",
    fill: "white"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask22_338_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.829 178.853V67.2012C194.219 81.0449 199.774 129.56 199.774 148.106C199.774 166.718 194.109 165.914 190.964 168.303C189.199 169.646 189.367 178.855 189.367 178.855H186.829V178.853Z",
    fill: "#49A073"
  }))))), /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask23_338_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 173,
    y: 67,
    width: 14,
    height: 112
  }, _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M186.83 67.2012H173.877V178.853H186.83V67.2012Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask23_338_318)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask24_338_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 173,
    y: 67,
    width: 14,
    height: 112
  }, _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M186.83 67.2012H173.877V178.853H186.83V67.2012Z",
    fill: "white"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask24_338_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M186.83 178.853V67.2012C179.438 81.0449 173.877 129.56 173.877 148.106C173.877 166.718 179.559 165.914 182.688 168.303C184.458 169.646 184.285 178.855 184.285 178.855H186.83V178.853Z",
    fill: "#15925D"
  }))))), /*#__PURE__*/React.createElement("mask", {
    id: "mask25_338_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 177,
    y: 93,
    width: 20,
    height: 73
  }, _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M196.673 93.6602H177.067V165.377H196.673V93.6602Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask25_338_318)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask26_338_318",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 177,
    y: 93,
    width: 20,
    height: 73
  }, _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M196.673 93.6602H177.067V165.377H196.673V93.6602Z",
    fill: "white"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask26_338_318)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.673 155.552C196.673 160.981 192.283 165.377 186.867 165.377C181.457 165.377 177.067 160.981 177.067 155.552C177.067 150.123 186.825 93.6602 186.825 93.6602C186.825 93.6602 196.673 150.123 196.673 155.552Z",
    fill: "#DE2428"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_338_318"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 178.022,
    height: 180,
    fill: "white",
    transform: "translate(101 60)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSaf);
export default __webpack_public_path__ + "static/media/saf.6405915acca81404473195c69c786b6d.svg";
export { ForwardRef as ReactComponent };